export * from "./d-avatar.js";
